import React from 'react';
import { Default } from '../../layouts';

import { useEditPage } from '../../hooks/useEditPage';

import { create, findOne, update } from '../../services/orders';

import { CUSTOMER_TYPE, ORDER_STATUS } from './constants';
import EditIndividualOrderForm from '../../components/individual-orders/EditIndividualOrderForm';

const initialOrderData = {
  attachments: [],
  products: [],
  commandType: 'EXTERNAL',
  status: ORDER_STATUS.SELECT_PRODUCTS,
  deleted: false,
  customerType: CUSTOMER_TYPE.INDIVIDUAL,
};

const EditIndividulaOrder = () => {
  const [order, handleSubmit, handleCancel] = useEditPage({
    initial: initialOrderData,
    existent: findOne,
    goBackPath: '/individual-orders',
    onCreate: create,
    onUpdate: update,
  });

  return (
    <Default>
      {order !== undefined && (
        <EditIndividualOrderForm
          order={{
            ...order,
            disabled: order.status !== ORDER_STATUS.SELECT_PRODUCTS,
          }}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}
    </Default>
  );
};

export default EditIndividulaOrder;
